import { createContext, useContext } from 'react'

export type SchemaIdentityProperties = Record<string, Record<string, boolean>>

const SchemaIdentityContext = createContext<SchemaIdentityProperties | null>(null)

export const SchemaIdentityProvider = SchemaIdentityContext.Provider

export function useSchemaIdentityProperties(): SchemaIdentityProperties | null {
  return useContext(SchemaIdentityContext)
}
